<template>
  <tr>
    <td data-th="Product">
      <h4 class="nomargin" :class="{'sold-out-name': product.count === 0}">
        {{ product.name }}
        <span
          v-if="product.count === 0"
          class="badge badge-pill badge-danger"
        >Agotado</span>
      </h4>
      <p>{{ product.description }}</p>
    </td>
    <td data-th="Price">
      {{ product.unitPrice | currency('Bs.', 2, {
      thousandsSeparator: ".",
      decimalSeparator: ",",
      symbolOnLeft: true,
      spaceBetweenAmountAndSymbol: true
      })
      }}
    </td>
    <td data-th="Quantity">{{ product.originalCount }}</td>
    <td data-th="Count" :class="{'text-danger': product.count === 0}">{{ count }}</td>
    <td data-th="Subtotal" class="text-center">
      {{ product.total | currency('Bs.', 2, {
      thousandsSeparator: ".",
      decimalSeparator: ",",
      symbolOnLeft: true,
      spaceBetweenAmountAndSymbol: true
      })
      }}
    </td>
  </tr>
</template>

<script>
export default {
  props: ["product", "status"],
  computed: {
    count() {
      return this.status == "P" ? "Pendiente" : this.product.count
    }
  }
};
</script>


<style scoped>
.sold-out-name {
  text-decoration: line-through;
}
</style>
